export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close',
    '_11148_READ': 'Read',
    '_11147_UNREAD': 'Unread',
    '_9496_DELETED': 'Deleted',
    '_11149_MARK_AS_READ': 'Mark as Read',
    '_11150_MARK_AS_UNREAD': 'Mark as Unread',
    '_7424_DELETE': 'Delete',
    '_11151_COMPLETE_ACTION': 'Complete Action'
};
